import type { WorkspaceItem } from '@/features/account'

/** ORP-20186: the page stays reachable for one week after the workspace is created. */
export const GET_STARTED_WINDOW_MS = 7 * 24 * 60 * 60 * 1000
export const GET_STARTED_PREFERENCE_KEY = 'get_started_progress'

export interface GetStartedPreference {
  version: 1
  hidden: boolean
}

export function normalizeGetStartedPreference(value: unknown): GetStartedPreference {
  const candidate = Array.isArray(value) ? value[0] : value
  if (!candidate || typeof candidate !== 'object') return { version: 1, hidden: false }
  return {
    version: 1,
    hidden: (candidate as Record<string, unknown>).hidden === true,
  }
}

export interface GetStartedAccessOptions {
  onlyDashboard?: boolean
  hidden?: boolean
  now?: number
}

/**
 * Legacy parity (`Orphex-New-Front` `getStartedAccess.ts`): Get Started is a new-account journey,
 * so every workspace on the account must be younger than the window. One older workspace means
 * the account is not new and the page, its nav entry and the landing redirect all stay off. A
 * hidden page and dashboard-only access are ineligible too.
 */
export function isGetStartedAvailable(
  workspaces: readonly Pick<WorkspaceItem, 'created_at'>[] | null | undefined,
  options: GetStartedAccessOptions = {},
): boolean {
  if (options.hidden || options.onlyDashboard) return false
  if (!Array.isArray(workspaces) || workspaces.length === 0) return false
  const now = options.now ?? Date.now()
  return workspaces.every((workspace) => {
    const createdAt = Date.parse(String(workspace?.created_at ?? ''))
    return Number.isFinite(createdAt) && now - createdAt < GET_STARTED_WINDOW_MS
  })
}
